<template>
<TitleCard :title="titleCard" :showMore="showMore">
  <div class="backStack-table-wrap">
    <div class="head-top-wrap">
      <TableTotalWrap :result="totalCounts" :auditStatus="auditStatus" @change="handlerStatusCheck"></TableTotalWrap>
      <div class="form-table-wrap">
        <Form ref="form" layoutType="grid" :optionList="formRow" :defaultModel="defaultValue"></Form>
        <div class="operation-wrap">
          <a-button @click="clearAll">清空条件</a-button>
          <a-button @click="toSearch">搜索</a-button>
        </div>
      </div>
      <TableToolsWrap needLeft :btnList="utilsBtnList" @utilsClick="handlerActionClick"></TableToolsWrap>
    </div>
    <Table 
      ref="table"
      :options="fields"
      :tableValue="tableValue"
      :customSlotOpt="slotOpt"
      :otherOpt="customOtherOpt"
      @change="initTableValue"
      @actionClick="handlerActionClick"></Table>
  </div>
  <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
</TitleCard>
</template>

<script>
import { mapGetters } from 'vuex'
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import TableTotalWrap from '../../components/common/tableTotalWrap.vue'
import AModal from '../../components/AModal'
import makeFakerData from '@/mixins/makeFakerData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import {
  fields,
  slotOpt,
  formRow
} from './configs/configs'
import {
  getDemandList,
  deleteDemandInfos,
  issueDemandInfos,
  getCounts
} from '@/api/demandInfos.js'

export default {
  mixins: [mixinsBackStack, makeFakerData],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      defaultSearchParam: {}, // 默认的搜索参数
      auditStatus: '0',
      customOtherOpt: { // 传入表格中的分页器配置
        pagination: {
          total: 0,
          pageSize: 10,
          pageNum: 1
        }
      },
      tableValue: [],
      totalCounts: [], // 头部的统计值
      defaultValue: {
        searchValue: '0'
      },
      utilsBtnList: []
    }
  },
  components: {
    TableTotalWrap,
    Table,
    AModal,
    Form,
    TableToolsWrap
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
    this.handlerTableSlot()
    this.getTotalCount(getCounts)  // 获取表格的统计数量
  },
  computed: {
    ...mapGetters('user', [
      'role'
    ])
  },
  methods: {
    handlerStatusCheck(v) {
      this.auditStatus = v
      this.initSearchParams()
      this.initPagination() // 初始化分页器
      // 处理操作栏
      this.handlerTableSlot()
      this.handlerTableHeadOperationBtn() // 表格上方的操作按钮
      this.initTableValue()
    },
    // 处理表格头部的控制按钮的显示
    handlerTableHeadOperationBtn() {
      const forbiddenMap = ['0', '2'] // 待审核 和 不通过不显示发布和下架功能
      let utilsBtnList = []
      if(!forbiddenMap.includes(this.auditStatus)) {
        utilsBtnList =  [
          { name: '发布', cb: 'issue' },
          { name: '下架', cb: 'drop' }
        ]
        // 企业用户没有发布、下架权限
        if (this.role === 'user') {
          utilsBtnList = []
        }
      }
      this.utilsBtnList = utilsBtnList
    },
    // 处理表格的操作按钮
    handlerTableSlot() {
      const status = this.auditStatus
      const target = this.slotOpt.find(item => item.slot === 'action')
      if(!target) return
      let initSlot = [{ name: '删除', cb: 'delete' }]
      if(status === '2') {
        initSlot = [
          { name: '编辑', cb: 'edit' },
          { name: '删除', cb: 'delete', divider: true }
        ]
      }
      // 审核通过的，企业用户没有删除权限
      if (status === '1' && this.role === 'user') {
        initSlot = []
      }
      target.list = initSlot
    },
    async initTableValue() {
      try {
        this.loadingTable(true) // 开启表格的加载动画
        const params = this.dealSearchFormParams()
        const { data } = await getDemandList(params) // 请求表格数据接口
        const { rows, total } = data
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination = {
          total: total
        }
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
      } finally {
        this.loadingTable(false)
      }
    },
    // 处理搜索表单的值
    dealSearchFormParams() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      return { 
        ...this.searchParam,
        pageSize,
        pageNum
      }
    },
    // 编辑
    edit(row) {
      const {id} = row
      this.$router.push({ name: 'demandIssue', query:{ id, type: 'edit' }})
    },
    // 前往详情
    toDetail(row) {
      const {id} = row.scope
      this.$router.push({ name: 'demandIssue', query:{ id, type: 'detail' }})
    },
    // 发布
    issue() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的需求信息')
      }
      const status = 1
      const ids = selectedIds.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定发布该内容'
      this.beforeShowModal(true, {
        source: 'dealIssueApi',
        params: { ids: { ids, status } }
      })
      this.getTotalCount(getCounts)  // 获取表格的统计数量
    },
    // 调用发布接口
    async dealIssueApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await issueDemandInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 下架
    drop() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const ids = selectedIds.map((item) => item.id)
      const status = 0
      this.customModalOpt.contentTips = '是否确定下架已选的需求信息'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的需求信息')
      }
      this.beforeShowModal(true, {
        source: 'dealDropApi',
        params: { ids: { ids, status } }
      })
      this.getTotalCount(getCounts)  // 获取表格的统计数量
    },
    // 调用下架接口
    async dealDropApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await issueDemandInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    delete(row) {
      this.customModalOpt.contentTips = '是否确定删除该内容'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteDemandInfos(ids)
        this.initTableValue()
        this.getTotalCount(getCounts)  // 获取表格的统计数量
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    }
  }
}
</script>
